import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService, SKIP_ERROR_INTERCEPTOR } from '../services/security/auth.service';
import { ToastService } from '@infinitform/shared-ui';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !window.location.href.includes('/login')) {
        // SECURE: Clear all user data and redirect to login without refresh loop
        authService.clearTokens();
        router.navigate(['/login']);
      }

      // Handle permission denied errors (403)
      if (err.status === 403) {
        const errorMessage = err.error?.error?.message || 'You do not have permission to perform this action';
        const errorCode = err.error?.error?.code;

        if (errorCode === 'AUTHORIZATION_ERROR') {
          toastService.show({ type: 'warning', text: errorMessage });
        } else {
          toastService.show({ type: 'error', text: 'Access denied: Insufficient permissions' });
        }
      } else if (err.status === 404) {
        toastService.show({ type: 'error', text: 'Resource not found' });
      } else if (err.status === 400) {
        const errorMessage = err.error?.error?.message || 'Bad request';
        const errorCode = err.error?.error?.code;

        if (errorCode === 'VALIDATION_ERROR') {
          toastService.show({ type: 'error', text: errorMessage });
        } else {
          toastService.show({ type: 'error', text: 'Bad request' });
        }
      }

      if (request.context.get(SKIP_ERROR_INTERCEPTOR)) {
        return throwError(() => err);
      }

      const error = err.error?.error || err.error?.message || err.statusText;
      return throwError(() => error);
    })
  );
};
